export default __webpack_public_path__ + "static/media/blog-39-2.0c85eb8f.jpg";